export default {
  name: 'dicom-plus-modal-duplicar-exame',
  inject: ['dicomPlusModal'],
  computed: {
    m() {
      return this.dicomPlusModal
    }
  }
}
